import { render, staticRenderFns } from "./ScreenLaudoObstetrica1Trimestre.vue?vue&type=template&id=7038d1de&lang=true&"
import script from "./ScreenLaudoObstetrica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoObstetrica1Trimestre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports